import script from "./ui-tabs.vue?vue&type=script&lang=js"
export * from "./ui-tabs.vue?vue&type=script&lang=js"

const __exports__ = script;

export default __exports__